import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { DomainProvider } from "../../../Models/Domain/Domain.Context";
import { NavBar } from "../../../Models/NavBar/NavBar.Model";
import PushNotificationsModel from "../../../Models/PushNotifications/PushNotifications.Model";
import { GlobalSearchRoot } from "../../../Search/GlobalSearchRoot";
import { NavDrawer } from "../NavDrawer/NavDrawer";
import { HamburgerButton } from "./Components/HamburgerButton/HamburgerButton";
import { NavBarRightSection } from "./Components/NavBarRightSection/NavBarRightSection";
import "./NavBarView.scss";

export const NavBarLayout: React.FC<any> = () => {
  useEffect(() => {
    PushNotificationsModel.refresh();
  }, []);

  return (
    <DomainProvider>
      <GlobalSearchRoot />
      <NavBarView />
      <NavDrawer />
      <div className="pageContent navBarPageContent">
        <Outlet />
      </div>
    </DomainProvider>
  );
};

export const NavBarView = () => {
  const { left, center, right } = NavBar.useState((s) => s);

  return (
    <header className="NavBar">
      <div className="leftNav flex items-center gap-2">
        <HamburgerButton />
        {left}
      </div>
      <div className="centerNav flex items-center justify-center">{center}</div>
      <div className="centerNavSpacer" />
      <div className="rightNav flex items-center justify-end">{right || <NavBarRightSection />}</div>
    </header>
  );
};
